import Question from "./Question";

export default class Cosmoform {
  constructor({
    id,
    question,
    answer = null,
    updated = false,
    dateCreated,
    isSequential = false,
  }) {
    this.id = id;
    this.question = new Question(question);
    this.answer = answer && Array.isArray(answer) ? answer[0] : answer;
    this.updated = updated;
    this.dateCreated = dateCreated;
    this.isSequential = isSequential;
    if (
      this.answer &&
      this.answer.choices?.length > 0 &&
      isNaN(this.answer.choices[0])
    ) {
      this.answer.choices = this.answer.choices.map((c) => c.id);
    }
  }
}

export class CosmoformTemplate {
  constructor({
    id,
    title,
    description,
    emailContent,
    dateCreated,
    dateUpdated,
    accountRequired,
    formTemplateQuestions,
    validationSchemas,
    questionTemplates,
    isSequential,
    questions,
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.emailContent = emailContent;
    this.dateCreated = dateCreated;
    this.dateUpdated = dateUpdated;
    this.accountRequired = accountRequired;
    this.isSequential = isSequential;
    this.validationSchemas = validationSchemas?.length ? validationSchemas : [];
    this.questionTemplates = questionTemplates?.length ? questionTemplates : [];
    this.formTemplateQuestions = formTemplateQuestions;
    // to remove once sequential is merged and questionTemplates are used instead of questions
    this.questions = questions?.length
      ? questions.map((q) => new Question(q))
      : [];
  }

  setDetail({ description, emailContent, dateUpdated, accountRequired }) {
    this.description = description;
    this.emailContent = emailContent;
    this.dateUpdated = dateUpdated;
    this.accountRequired = accountRequired;
  }
}
